/* ============
 * Order Transformer
 * ============
 *
 * The transformer for the order.
 */

import Transformer from './transformer';
import billTransformer from './bill';
import wareTransformer from './warehouse';
import clientTransformer from './client';
import bookingTransformer from './booking';
import ediOrderTransformer from './ediOrder';
import moment from 'moment';

export default class OrderTransformer extends Transformer {
  static fetch(order) {
    return {
      id: order.id,
      number: order.number,
      createdAt: order.created_at,
      totalValue: order.total_value,
      totalQuantity: order.total_quantity,
      productId: order.product_id,
      roundInvoiceTotal: order.round_invoice_total,
      hashid: order.hashid,
      clientId: order.client_id,
      clientName: order.client_name,
      serviceName: order.service_name,
      orderTypeId: order.order_type_id,
      ediOrderId: order.edi_order_id,
      ediRequestedDeliveryDate: order.edi_requested_delivery_date,
      ediStatus: order.edi_status,
      ediType: order.edi_type,
      ediStore: order.edi_store,
      orderNumber: order.order_number,
      zreOrderSource: order.zre_order_source,
      zreOrderSourceOrderNumber: order.zre_order_source_order_number,
      orderStatusId: order.order_status_id,
      orderStatus: order.order_status,
      orderType: order.order_type,
      discount: order.discount,
      sent: order.sent,
      date: order.date,
      time: order.time,
      duration: order.duration,
      details: order.details,
      bills: order.bills !== undefined ? billTransformer.fetchCollection(order.bills) : undefined,
      warehouseId: order.warehouse_id,
      warehouse: order.warehouse !== undefined ? wareTransformer.fetch(order.warehouse) : [],
      client: order.client !== undefined ? clientTransformer.fetch(order.client) : [],
      booking: order.booking !== undefined ? bookingTransformer.fetch(order.booking) : [],
      referenceNumber: order.reference_number,
      ediOrder: order.edi_order !== undefined ? ediOrderTransformer.fetch(order.edi_order) : [],
      shippingProvider: order.shipping_provider,
      createdDate: order.created_date,
      orderTrackingNumber: order.tracking_number,
      trackingUrl: order.tracking_url,
      orderProducts: order.order_products,
      isVinmonopolet: order.is_vinmonopolet,
      isAsko: order.is_asko,
      isRema: order.is_rema,
      isCoop: order.is_coop,
      orderPickupId: order.order_pickup_id,
      pickup: order.pickup,
      pickupDate: order.pickup_date,
      pickupBy: order.pickup_by,
      pickupStatus: order.pickup_status,
      deliveryDate: order.delivery_date,
      shippingDate: order.shipping_date,
      note: order.note,
      internalNote: order.internal_note,
      isBilled: order.is_billed,
      sendVia: order.send_via,
      projectId: order.project_id,
    };
  }

  static send(order) {
    return {
      id: order.id,
      number: order.number,
      round_invoice_total: order.roundInvoiceTotal,
      hashid: order.hashid,
      client_id: order.clientId,
      product_id: order.productId,
      order_type_id: order.orderTypeId,
      edi_order_id: order.ediOrderId,
      discount: order.discount,
      sent: order.sent,
      created_at: order.createdAt,
      date: order.date ? moment(order.date).format('YYYY-MM-DD') : '',
      time: order.time,
      duration: order.duration,
      details: order.details,
      warehouse_id: order.warehouseId,
      batch_id: order.batchId,
      reference_number: order.referenceNumber,
      internal_note: order.internalNote,
      invoice_external: (order.invoiceExternal) ? order.invoiceExternal : false,
      order_confirm_notification: order.orderConfirmNotification,
      project_id: order.projectId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/order.js